import { ClaimStatus } from './enums.js'

export const SUGGESTED_NEXT_SWAP_CLAIM_STATUSES: Partial<Record<ClaimStatus, ClaimStatus[]>> = {
    [ClaimStatus.PENDING]: [ClaimStatus.WAITINGFORPAYMENT],
    [ClaimStatus.WAITINGFORPAYMENT]: [ClaimStatus.PAYMENTRECEIVED, ClaimStatus.PAYMENTERROR],
    [ClaimStatus.PAYMENTRECEIVED]: [ClaimStatus.APPROVED, ClaimStatus.DECLINED],
    [ClaimStatus.PAYMENTERROR]: [ClaimStatus.WAITINGFORPAYMENT],
    [ClaimStatus.APPROVED]: [ClaimStatus.RETURNKITSENT],
    [ClaimStatus.RETURNKITSENT]: [ClaimStatus.DEVICERECEIVED, ClaimStatus.DEVICENOTRECEIVED],
    [ClaimStatus.DEVICERECEIVED]: [ClaimStatus.COMPLETED],
}

export const SUGGESTED_NEXT_CANCEL_CLAIM_STATUSES: Partial<Record<ClaimStatus, ClaimStatus[]>> = {
    [ClaimStatus.PENDING]: [ClaimStatus.APPROVED],
    [ClaimStatus.SENDRETURNKIT]: [ClaimStatus.RETURNKITSENT],
    [ClaimStatus.APPROVED]: [ClaimStatus.RETURNKITSENT],
    [ClaimStatus.RETURNKITSENT]: [ClaimStatus.DEVICERECEIVED, ClaimStatus.DEVICENOTRECEIVED],
    [ClaimStatus.DEVICERECEIVED]: [ClaimStatus.DEVICERECEIVEDAPPROVED, ClaimStatus.DEVICERECEIVEDDAMAGED],
    [ClaimStatus.DEVICENOTRECEIVED]: [ClaimStatus.BILLINGREACTIVATED],
    [ClaimStatus.DEVICERECEIVEDAPPROVED]: [ClaimStatus.COMPLETED],
}

export const DEFAULT_REMORSE_RETURN_DAYS = 30
export const TEST_USER_AGENT = 'test-agent'

export const SIMULATED_PERSONAL_NUMBER_FI = '010200A9618'
export const SIMULATED_PERSONAL_NUMBER_SE = '196604102944'
export const SIMULATED_PERSONAL_NUMBER_DK = '0209270366'
